export default __webpack_public_path__ + "static/media/supernotariado.5956743e.png";